<template>
  <page-status class="order-pay" :loading="loading">
    <page-result :image="imgError" title="错误提示" desc="支付失败请重新尝试">
      <div class="reload-action">
        <van-button block type="info" @click="onReload">请重试</van-button>
      </div>
    </page-result>
  </page-status>
</template>

<script>
import * as qs from 'qs';

import PageStatus from '@/components/PageStatus';
import PageResult from '@/components/PageResult';
import imgError from '@/assets/img-status-error.png';
import * as constants from '@/utils/constants';
import * as services from '@/services';

export default {
  name: 'OrderPay',
  components: {
    PageStatus,
    PageResult,
  },

  data() {
    return {
      loading: true,
      imgError,
    };
  },

  created() {
    const { platform } = this.$route.query;
    if (platform === 'alipay') {
      this.handleAlipay();
    } else {
      this.handleWechat();
    }
  },

  methods: {
    onReload() {
      const { orderNo, platform } = this.$route.query;
      const location = window.location;
      const search = qs.stringify({ orderNo, platform });
      const url = `${location.origin}${location.pathname}`;
      window.location.replace([url, search].join('?'));
    },

    orderPayment(orderNo, paymentType, code, proposalNo, appid) {
      services
        .orderPayment(orderNo, paymentType, code, proposalNo, appid)
        .then(res => window.location.replace(res.data))
        .catch(res => (this.loading = false));
    },

    handleAlipay() {
      const { orderNo, auth_code, proposalNo } = this.$route.query;

      if (auth_code) {
        this.orderPayment(
          orderNo,
          '02',
          auth_code,
          proposalNo,
          '2015092100309186',
        );
      } else {
        const redirect_uri = window.location.href;
        const search = qs.stringify({ redirect_uri, scope: 'auth_user' });
        // const host = window.location.host;
        // if (host === 'test-motor.cathay-ins.com.cn') {
        //   const url =
        //     'https://test-m.cathay-ins.com.cn/alipay/oauth2/authorize';
        //   window.location.replace([url, search].join('?'));
        // } else if (host === 'aliyun-hotfix-motor.cathay-ins.com.cn') {
        //   const url =
        //     'https://hotfix-mc.cathay-ins.com.cn/alipay/oauth2/authorize';
        //   window.location.replace([url, search].join('?'));
        // } else {
        const url = 'https://app.cathay-ins.com.cn/alipay/oauth2/authorize';
        window.location.replace([url, search].join('?'));
        // }
      }
    },

    handleWechat() {
      const { orderNo, code, proposalNo } = this.$route.query;
      const appid = 'wxe15d3c0802480692';
      if (code) {
        this.orderPayment(orderNo, '03', code, proposalNo, appid);
      } else {
        const redirect_uri = window.location.href;
        const search = qs.stringify({ appid, redirect_uri });
        // const host = window.location.host;
        // if (host === 'test-motor.cathay-ins.com.cn') {
        //   const url =
        //     'https://test-m.cathay-ins.com.cn/wechat/oauth2/authorize';
        //   window.location.replace([url, search].join('?'));
        // } else if (host === 'aliyun-hotfix-motor.cathay-ins.com.cn') {
        //   const url =
        //     'https://hotfix-mc.cathay-ins.com.cn/wechat/oauth2/authorize';
        //   window.location.replace([url, search].join('?'));
        // } else {
        const url = 'https://app.cathay-ins.com.cn/wechat/oauth2/authorize';
        window.location.replace([url, search].join('?'));
        // }
      }
    },
  },
};
</script>

<style lang="less">
.order-pay {
  height: 100%;

  .reload-action {
    margin: 12px 16px;
  }
}
</style>
